<div
    class="supporting-documentation__container"
    *ngIf="!readOnlyUser && canViewSupportingDocumentation"
    [class.supporting-documentation__container--collapsed]="!isExpanded"
>
    <div class="supporting-documentation__header">
        <h3 class="supporting-documentation__title">
            <button class="supporting-documentation__toggle" type="button"
                [attr.aria-expanded]="isExpanded"
                [attr.aria-controls]="'supporting-documentation-content-' + componentId"
                (click)="toggleExpanded(); $event.stopPropagation()">
                <span>Supporting Documentation</span>
            </button>
        </h3>
        <div class="supporting-documentation__header-actions">
            <button nz-button nzType="primary" nzSize="small" type="button"
                class="cb4-button supporting-documentation__add"
                (click)="onAddLinkClicked(); $event.stopPropagation()"
                [disabled]="isLoading || isFormVisible || editingLinkId !== null || (!hasSelection && !aggregateByLicense) || readOnlyUser">
                <i nz-icon nzType="plus" aria-hidden="true"></i>
                <span>Add Link</span>
            </button>
            <button class="supporting-documentation__collapse-toggle" type="button"
                [attr.aria-label]="isExpanded ? 'Collapse Supporting Documentation' : 'Expand Supporting Documentation'"
                [attr.aria-expanded]="isExpanded"
                [attr.aria-controls]="'supporting-documentation-content-' + componentId"
                (click)="toggleExpanded(); $event.stopPropagation()">
                <span nz-icon [nzType]="isExpanded ? 'up' : 'down'" aria-hidden="true"></span>
            </button>
        </div>
    </div>
    <div class="supporting-documentation__content"
        [class.supporting-documentation__content--expanded]="isExpanded"
        [attr.aria-hidden]="!isExpanded">
        <div class="supporting-documentation__content-inner"
            [id]="'supporting-documentation-content-' + componentId"
            [attr.inert]="isExpanded ? null : ''">
        
        <p class="supporting-documentation__not-included">Only administrators and assessors assigned to this assessment can see this.<br />This will not be included in the completed report.</p>

        <form
            *ngIf="isFormVisible"
            class="supporting-documentation__form"
            [formGroup]="linkForm"
            novalidate
            (ngSubmit)="onSubmitLink()"
        >
            <div class="supporting-documentation__form-row">
                <div class="supporting-documentation__form-field supporting-documentation__type-wrapper">
                    <label
                        class="supporting-documentation__form-label"
                        [attr.for]="'supporting-documentation-type-' + componentId"
                    >
                        Type:
                    </label>
                    <div class="supporting-documentation__input-wrapper">
                        <nz-select
                            formControlName="type"
                            class="supporting-documentation__select"
                            [id]="'supporting-documentation-type-' + componentId"
                            nzDropdownClassName="supporting-documentation__select-dropdown"
                            nzPlaceHolder="Select type"
                        >
                            <nz-option
                                *ngFor="let option of linkTypeOptions"
                                [nzValue]="option"
                                [nzLabel]="option"
                            ></nz-option>
                        </nz-select>
                        <ng-container *ngIf="isCustomTypeSelected">
                            <input
                                nz-input
                                formControlName="customType"
                                autocomplete="off"
                                class="supporting-documentation__input"
                                [attr.aria-label]="'Specify supporting documentation type'"
                                [attr.maxlength]="customTypeMaxLength"
                                [id]="'supporting-documentation-custom-type-' + componentId"
                                placeholder="Enter type"
                            />
                            <span
                                class="supporting-documentation__error"
                                *ngIf="
                                    linkForm.controls.customType.touched &&
                                    (linkForm.controls.customType.errors?.required ||
                                        linkForm.controls.customType.errors?.whitespace)
                                "
                            >
                                Enter a type.
                            </span>
                            <span
                                class="supporting-documentation__error"
                                *ngIf="linkForm.controls.customType.errors?.maxlength"
                            >
                                Type must be {{ customTypeMaxLength }} characters or fewer.
                            </span>
                        </ng-container>
                    </div>
                </div>

                <div class="supporting-documentation__form-field">
                    <label
                        class="supporting-documentation__form-label"
                        [attr.for]="'supporting-documentation-name-' + componentId"
                    >
                        Name:
                    </label>
                    <div class="supporting-documentation__input-wrapper">
                        <input
                            nz-input
                            formControlName="displayName"
                            autocomplete="off"
                            class="supporting-documentation__input"
                            [id]="'supporting-documentation-name-' + componentId"
                        />
                        <span
                            class="supporting-documentation__error"
                            *ngIf="
                                linkForm.controls.displayName.touched &&
                                (linkForm.controls.displayName.errors?.required || linkForm.controls.displayName.errors?.whitespace)
                            "
                        >
                            A name is required.
                        </span>
                        <span
                            class="supporting-documentation__error"
                            *ngIf="linkForm.controls.displayName.errors?.maxlength"
                        >
                            Name must be 255 characters or fewer.
                        </span>
                    </div>
                </div>

                <div class="supporting-documentation__form-field">
                    <label
                        class="supporting-documentation__form-label"
                        [attr.for]="'supporting-documentation-url-' + componentId"
                    >
                        URL:
                    </label>
                    <div class="supporting-documentation__input-wrapper">
                        <input
                            nz-input
                            formControlName="url"
                            autocomplete="off"
                            class="supporting-documentation__input"
                            [id]="'supporting-documentation-url-' + componentId"
                        />
                        <span
                            class="supporting-documentation__error"
                            *ngIf="
                                linkForm.controls.url.touched &&
                                (linkForm.controls.url.errors?.required || linkForm.controls.url.errors?.whitespace)
                            "
                        >
                            A URL is required.
                        </span>
                        <span class="supporting-documentation__error" *ngIf="linkForm.controls.url.errors?.url">
                            Enter a valid URL.
                        </span>
                        <span class="supporting-documentation__error" *ngIf="linkForm.controls.url.errors?.maxlength">
                            URL must be 2048 characters or fewer.
                        </span>
                    </div>
                </div>

                <div class="supporting-documentation__form-actions">
                    <button
                        nz-button
                        class="cb4-button"
                        nzType="primary"
                        nzSize="small"
                        type="submit"
                        [disabled]="isSubmitting"
                        [nzLoading]="isSubmitting"
                    >
                        Submit
                    </button>
                    <button
                        nz-button
                        class="cb4-button"
                        nzType="default"
                        nzSize="small"
                        type="button"
                        (click)="onCancelForm()"
                        [disabled]="isSubmitting"
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </form>

        <div class="supporting-documentation__filters">
            <button *ngIf="!areFiltersVisible; else supportingDocumentationFilters"
                nz-button nzType="link" nzSize="small" type="button"
                class="supporting-documentation__filter-reveal" (click)="showFilters()">
                <span nz-icon nzType="filter" aria-hidden="true"></span>
                Search / Filter
            </button>
            <ng-template #supportingDocumentationFilters>
                <div class="supporting-documentation__filter-controls">
                    <div class="supporting-documentation__filter-field">
                        <input nz-input type="search" maxlength="256"
                            [id]="'supporting-documentation-search-' + componentId"
                            [disabled]="isSubmitting || editingLinkId !== null"
                                [ngModel]="linkSearchText" (ngModelChange)="onLinkSearchChange($event)"
                            placeholder="Search evidence name, type, or URL" />
                    </div>
                    <div class="supporting-documentation__filter-field">
                        <nz-select [id]="'supporting-documentation-authors-' + componentId"
                            nzMode="multiple" nzPlaceHolder="Filter by user"
                            aria-label="Filter supporting documentation by user"
                            [nzAllowClear]="true" [nzDisabled]="isSubmitting || editingLinkId !== null"
                                [ngModel]="selectedAuthorNames"
                            (ngModelChange)="onAuthorFilterChange($event)">
                            <nz-option *ngFor="let author of authorOptions" [nzValue]="author" [nzLabel]="author"></nz-option>
                        </nz-select>
                    </div>
                </div>
            </ng-template>
        </div>

        <nz-spin [nzSpinning]="isLoading" nzSize="small" class="supporting-documentation__spinner">
            <div *ngIf="isExpanded && filteredLinks.length > 0; else supportingDocumentationEmpty" class="supporting-documentation__table">
                <div
                    *ngFor="let link of filteredLinks; trackBy: trackById"
                    class="supporting-documentation__row"
                    [class.supporting-documentation__row--editing]="editingLinkId === link.id"
                    [@rowAnimation]
                >
                    <ng-container *ngIf="editingLinkId === link.id; else supportingDocumentationReadRow">
                        <div class="supporting-documentation__edit-fields" [formGroup]="linkForm">
                            <div class="supporting-documentation__form-field">
                                <label [attr.for]="'edit-supporting-type-' + componentId + '-' + link.id">Type</label>
                                <nz-select formControlName="type" class="supporting-documentation__select"
                                    [id]="'edit-supporting-type-' + componentId + '-' + link.id" [nzDisabled]="isSavingEdit">
                                    <nz-option *ngFor="let option of linkTypeOptions" [nzValue]="option" [nzLabel]="option"></nz-option>
                                </nz-select>
                                <input *ngIf="isCustomTypeSelected" nz-input formControlName="customType"
                                    [attr.maxlength]="customTypeMaxLength" [readOnly]="isSavingEdit"
                                    aria-label="Custom supporting documentation type" />
                                <span class="supporting-documentation__error" *ngIf="linkForm.controls.customType.touched && linkForm.controls.customType.invalid">Enter a type of up to 20 characters.</span>
                            </div>
                            <div class="supporting-documentation__form-field">
                                <label [attr.for]="'edit-supporting-name-' + componentId + '-' + link.id">Name</label>
                                <input nz-input formControlName="displayName" [attr.maxlength]="255" [readOnly]="isSavingEdit"
                                    [id]="'edit-supporting-name-' + componentId + '-' + link.id" />
                                <span class="supporting-documentation__error" *ngIf="linkForm.controls.displayName.touched && linkForm.controls.displayName.invalid">Enter a name of up to 255 characters.</span>
                            </div>
                            <div class="supporting-documentation__form-field">
                                <label [attr.for]="'edit-supporting-url-' + componentId + '-' + link.id">URL</label>
                                <input nz-input formControlName="url" [attr.maxlength]="2048" [readOnly]="isSavingEdit"
                                    [id]="'edit-supporting-url-' + componentId + '-' + link.id" />
                                <span class="supporting-documentation__error" *ngIf="linkForm.controls.url.touched && linkForm.controls.url.invalid">Enter a valid HTTP or HTTPS URL of up to 2048 characters.</span>
                            </div>
                        </div>
                        <div class="supporting-documentation__row-actions">
                            <button nz-button nzType="text" type="button" class="cb4-button supporting-documentation__delete"
                                (click)="onSaveEdit(link)" [disabled]="isSavingEdit" [attr.aria-label]="'Save changes to ' + link.displayName">
                                <i nz-icon [nzType]="isSavingEdit ? 'loading' : 'check'" class="supporting-documentation__delete-icon"></i>
                            </button>
                            <button nz-button nzType="text" type="button" class="cb4-button supporting-documentation__delete"
                                (click)="onCancelEdit()" [disabled]="isSavingEdit" [attr.aria-label]="'Cancel changes to ' + link.displayName">
                                <i nz-icon nzType="close" class="supporting-documentation__delete-icon"></i>
                            </button>
                        </div>
                    </ng-container>
                    <ng-template #supportingDocumentationReadRow>
                    <div class="supporting-documentation__type">
                        <span class="supporting-documentation__type-badge">{{ link.type }}</span>
                    </div>
                    <div class="supporting-documentation__link">
                        <ng-template #supportingDocumentationPlainLink>
                            <span>{{ link.displayName }}</span>
                        </ng-template>
                        <ng-container
                            *ngIf="formatLinkHref(link.url) as linkHref; else supportingDocumentationPlainLink"
                        >
                            <a
                                [href]="linkHref"
                                target="_blank"
                                rel="noopener noreferrer"
                                [attr.title]="link.url"
                            >
                                <span>{{ link.displayName }}</span>
                                <i nz-icon nzType="export" class="supporting-documentation__external-link-icon" aria-hidden="true"></i>
                            </a>
                        </ng-container>
                    </div>
                    <div class="supporting-documentation__timestamp">
                        <span class="supporting-documentation__timestamp-date">
                            {{ link.createdAt | date: 'd MMM y \' at \' hh:mm' }}
                        </span>
                        <span
                            *ngIf="link.createdByDisplayName"
                            class="supporting-documentation__timestamp-author"
                        >
                            Added by {{ link.createdByDisplayName }}
                        </span>
                        <button
                            *ngIf="aggregateByLicense && getRequirementReferenceLabel(link.questionReference) as requirementLabel"
                            nz-button nzType="primary" nzSize="small"
                            class="cb4-button appendix-b__requirement-number supporting-documentation__requirement-link"
                            type="button" (click)="onRequirementReferenceClick(link.questionReference)"
                        >{{ requirementLabel }}</button>
                    </div>
                    <div class="supporting-documentation__row-actions">
                    <button *ngIf="canEditLink(link)"
                        nz-button nzType="text" type="button" class="cb4-button supporting-documentation__delete"
                        (click)="onEditLink(link)" [disabled]="deletingLinkIds.has(link.id) || isLoading || editingLinkId !== null"
                        [attr.aria-label]="'Edit ' + link.displayName">
                        <i nz-icon nzType="edit" class="supporting-documentation__delete-icon"></i>
                    </button>
                    <button *ngIf="canDeleteLink(link)"
                        nz-button
                        nzType="text"
                        type="button"
                        class="cb4-button supporting-documentation__delete"
                        (click)="onDeleteLink(link)"
                        [disabled]="deletingLinkIds.has(link.id) || readOnlyUser || editingLinkId !== null"
                        [attr.aria-label]="'Delete ' + link.displayName"
                    >
                        <i
                            nz-icon
                            *ngIf="!deletingLinkIds.has(link.id)"
                            nzType="close"
                            class="supporting-documentation__delete-icon"
                        ></i>
                        <i
                            nz-icon
                            *ngIf="deletingLinkIds.has(link.id)"
                            nzType="loading"
                            class="supporting-documentation__delete-icon"
                        ></i>
                    </button>
                    </div>
                    </ng-template>
                </div>
            </div>
        </nz-spin>

        <nz-pagination *ngIf="isExpanded && total > pageSize" [nzPageIndex]="pageIndex"
            [nzPageSize]="pageSize" [nzTotal]="total" [nzShowSizeChanger]="false"
            [nzDisabled]="isLoading || isSubmitting || isFormVisible || editingLinkId !== null || deletingLinkIds.size > 0"
            (nzPageIndexChange)="onPageChange($event)"></nz-pagination>

        <ng-template #supportingDocumentationEmpty>
            <div *ngIf="isExpanded && !isLoading" class="supporting-documentation__empty">
                {{ linkSearchText.trim() || selectedAuthorNames.length ? 'No supporting documentation matches these filters.' :
                    (aggregateByLicense ? 'No supporting documentation has been added for this assessment yet.' :
                    'No links to supporting evidence have been added for this requirement yet.') }}
            </div>
        </ng-template>
        </div>
    </div>
</div>
